<style src="./ModalChat.scss" lang="scss"></style>
<template lang="html">
  <section class="modal-chat">
    <h3>Comentários</h3>

    <form @submit.prevent="submitForm" class="comment-form">
      <icon-wait
        class="waiting"
        v-show="commands.waiting" />
      <textbox
        class="input-comment"
        label="Minha mensagem"
        placeholder="Escreva aqui e tecle ENTER para enviar"
        v-model="form.comment" />
    </form>

    <section class="message-container">
      <span
        class="no-message"
        v-show="comments.length < 1">Nenhum comentário foi feito até o momento</span>
      
      <ul
        class="messages-list"
        v-show="comments.length > 0">
        <li
          class="message"
          v-for="(message, messageIdx) in comments"
          :key="messageIdx">
          <span class="user">{{ getUserIdentification(message.user.name) }}</span>
          <div class="content">
            <span class="username">{{ message.user.name }}</span>
            <span class="moment">{{ message.moment | FriendlyVerboseDateTime }}</span>
            <span class="messagecontent">{{ message.comment }}</span>
          </div>
        </li>
      </ul>
    </section>
  </section>
</template>

<script>
import { Textbox, ButtonSubmit } from '@/components/primitives'
import { IconWait } from '@/components/primitives/icons'
import { FriendlyVerboseDateTime } from '@/components/primitives/helpers/filters'

export default {
  name: 'BidCapture',
  components: {
    IconWait,
    Textbox,
    ButtonSubmit
  },
  props: {
    stageId: null,
    eventId: null
  },
  data () {
    return {
      comments: [],
      form: {
        comment: ''
      },
      commands: {
        waiting: false
      }
    }
  },
  filters: {
    FriendlyVerboseDateTime
  },
  mounted () {
    this.listComments()
  },
  methods: {
    async submitForm () {
      this.commands.waiting = true
      const payload = {
        ...this.form,
        stageId: this.stageId,
        eventId: this.eventId
      }
      const username = this.$store.getters['Login/GET_USERNAME']
      try {
        const resultChat = await this.$store.dispatch('Board/CHAT_PUSH_MESSAGE', payload)
        this.comments.push({
          comment: this.form.comment,
          moment: resultChat.chat.moment,
          user: {
            name: username
          }
        })
        this.form.comment = ''
      } catch (error) {
        this.$toasted.error('Não foi possível enviar seu comentário')
      } finally {
        this.commands.waiting = false
      }
    },
    async listComments () {
      const payload = {
        stageId: this.stageId,
        eventId: this.eventId
      }
      const comments = await this.$store.dispatch('Board/CHAT_LIST_MESSAGES', payload)
      if (comments.success) {
        this.comments = comments.chat
      } else {
        this.comments = []
      }
    },
    getUserIdentification (name) {
      if (!name) return '@'
      const splittedName = name.split(' ')
      if (splittedName.length < 2) {
        const userIdentification = name.substr(0, 1) + name.substr(1, 1)
        return userIdentification.toUpperCase()
      } else {
        const userIdentification = splittedName[0].substr(0, 1) + splittedName[1].substr(0, 1)
        return userIdentification.toUpperCase()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/foundation/modal-chat/ModalChat.vue